export default "__VITE_ASSET__d7ef1d39__"